import api from './index';

export default {
  index(params) {
    return api({
      method: 'get',
      url: `api/transactions`,
      params,
    });
  },
  getById(id, params) {
    return api({
      method: 'get',
      url: `api/transactions/${id}`,
      params,
    });
  },
  update(id, data) {
    return api({
      method: 'patch',
      url: `api/transactions/${id}`,
      data,
    });
  },
};
